import authApi from "../../api/auth";
export default {
    namespaced: true,
    state: {
        username: localStorage.getItem("username") || null,
        isLogin: sessionStorage.getItem("isLogin") || null,
        token: localStorage.getItem("token") || null,
        accountType: localStorage.getItem("accountType") || null,
    },
    mutations: {
        save(state, payload) {
            localStorage.setItem("username", payload.username);
            sessionStorage.setItem("isLogin", true);
            localStorage.setItem("token", payload.token);
            localStorage.setItem("accountType", payload.accountType);
            // _vue.$http.defaults.headers.common["Authorization"] = "Bearer " + payload.token;
            state.username = payload.username;
            state.isLogin = true;
            state.token = payload.token;
            state.accountType = payload.accountType;
        },
        clearLoginInfo(state, payload) {
            sessionStorage.clear();
            localStorage.clear();
            // _vue.$http.defaults.headers.common["Authorization"] = "";
            state.token = null;
            state.isLogin = false;
            state.token = null;
        },
        setIsLogin(state, status) {
            state.isLogin = status;
            sessionStorage.setItem("isLogin", status);
        }
    },
    actions: {
        async login({commit, state}, {username, password}) {
            const result = await authApi.login(username, password);
            console.log(result)
            commit("save", result);
            return Promise.resolve();
        },
        async isLogin({commit, state}) {
            if(!state.isLogin) {
                await authApi.isLogin();
                commit("setIsLogin", true);
            }
            return Promise.resolve();
        }
    },
    getters: {
        enterpriseType: state => state.enterpriseInfo.type,
    },
}
